class StorefrontError extends Error {
  constructor(message, response, errors) {
    super(message);
    this.name = 'StorefrontError';
    this.response = response;
    this.errors = errors;
  }
}

// API URL/トークンは theme.liquid がサーバーサイド(Liquid)で
// 環境ごとに window.ikyuUrls に設定する。ここではそれを参照することで、
// このファイルに各環境のトークンをハードコードしないようにする。

// グローバルに利用できる関数として実装
window.storefront = async function(query, variables = {}) {
  try {
    const storefrontApiUrl = window.ikyuUrls?.storefrontApiUrl;
    const storefrontAccessToken = window.ikyuUrls?.storefrontAccessToken;

    // APIエンドポイントとアクセストークンの存在確認
    if (!storefrontApiUrl || !storefrontAccessToken) {
      throw new Error('Storefront API configuration is missing');
    }

    // Log the query being executed
    console.log('window.storefront executing query:', query);
    console.log('window.storefront variables:', JSON.stringify(variables));

    // fetchリクエストの実行
    const response = await fetch(storefrontApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // application/graphqlから修正
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    // レスポンスのJSON解析
    const json = await response.json();

    // HTTPエラーのチェック
    if (!response.ok) {
      console.error('Storefront API request failed:', {
        status: response.status,
        statusText: response.statusText,
        errors: json.errors
      });
      throw new StorefrontError(
        `Request failed with status ${response.status}`,
        response,
        json.errors
      );
    }

    // GraphQLエラーのチェック
    if (json.errors?.length > 0) {
      console.error('GraphQL errors:', json.errors);
      throw new StorefrontError('GraphQL Error', response, json.errors);
    }

    return json.data;
  } catch (error) {
    console.error('Storefront API error:', error);
    
    if (error instanceof StorefrontError) {
      throw error;
    }
    
    throw new StorefrontError(
      error instanceof Error ? error.message : 'Unknown error occurred'
    );
  }
};
